import { defineMessages } from 'react-intl';

export default defineMessages({
  yae: 'Yae',
  nay: 'Nay',
});
